import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "revenue-dashboard" }
const _hoisted_2 = { class: "dashboard-widgets" }
const _hoisted_3 = { class: "widget-row" }
const _hoisted_4 = { class: "widget-header" }
const _hoisted_5 = { class: "widget-body" }
const _hoisted_6 = { class: "widget-row" }
const _hoisted_7 = { class: "widget-header" }
const _hoisted_8 = { class: "widget-body" }
const _hoisted_9 = { class: "widget-row" }
const _hoisted_10 = { class: "widget-header" }
const _hoisted_11 = { class: "widget-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widgets.total, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "widget",
            key: 'total-' + index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, "₹ " + _toDisplayString(item.value), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widgets.paid, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "widget",
            key: 'paid-' + index
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", null, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, "₹ " + _toDisplayString(item.value), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widgets.unpaid, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "widget",
            key: 'unpaid-' + index
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h3", null, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, "₹ " + _toDisplayString(item.value), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"dashboard-charts\" data-v-0692825a><div class=\"chart\" data-v-0692825a><h3 data-v-0692825a>Total Revenue</h3><canvas id=\"totalRevenueChart\" data-v-0692825a></canvas></div><div class=\"chart\" data-v-0692825a><h3 data-v-0692825a>This Month</h3><canvas id=\"paidUnpaidThisMonthChart\" data-v-0692825a></canvas></div><div class=\"chart\" data-v-0692825a><h3 data-v-0692825a>This Year</h3><canvas id=\"paidUnpaidThisYearChart\" data-v-0692825a></canvas></div></div>", 1))
  ]))
}